// import React, { useEffect, useState } from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Home from "./pages/Home";
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// // import Communities from "./pages/communities";
// import Footer from "./components/footer";
// import WhatsAppButton from "./components/WhatsAppButton";
// import ListingDetails from "./pages/ListingDetails";
// import NotFound from "./pages/NotFound"; // Import the NotFound component
// import Aos from "aos";
// import "aos/dist/aos.css";
// import SignIn from "./pages/SignIn";
// import SignUp from "./pages/SignUp";
// import axios from "axios";
// import Blogs from "./pages/Blogs";
// import SellPage from "./pages/sale";
// import BuyPage from "./pages/buy";

// // axios.defaults.baseURL = 'http://127.0.0.1:5001/'; // local backend
// const isProduction = window.location.hostname === 'briankarsh.com';

// axios.defaults.baseURL = isProduction
//   ? 'https://briankarsh.com'  // Production backend
//   : 'http://127.0.0.1:5001/';  // Local development

// // axios.defaults.baseURL = 'https://briankarsh.com'; // local backend

// function App() {
//   const [role, setRole] = useState(null);

//   useEffect(() => {
//     const storedRole = localStorage.getItem('role'); // Assuming 'role' is saved in localStorage after login
//     setRole(storedRole || 'user'); // Default to 'user' if no role is found
//   }, []);

//   useEffect(() => {
//     Aos.init({
//       duration: 1000,
//     });
//   }, []);

//   // Hook to get the current route path
//   const location = useLocation();

//   // Check if the current route is SignIn or SignUp
//   const isAuthPage = location.pathname === "/sign-in" || location.pathname === "/sign-up";
  
//   // Check if current route is the 404 page to hide navbar and footer
//   const isNotFoundPage = location.pathname === "*";

//   return (
//     <div>
//       {/* Conditionally render Navbar and Footer only if not on SignIn, SignUp, or 404 page */}
//       {!isAuthPage && !isNotFoundPage && <Navbar />}
      
//       <div style={{ margin: 0, padding: 0 }}>
//         <Routes>
//           <Route path="/" element={<Home role={role} />} />
//           <Route path="/sign-in" element={<SignIn />} />
//           <Route path="/sign-up" element={<SignUp />} />
//           {/* <Route path="/communities" element={<Communities />} /> */}
//           <Route path="/about" element={<About role={role} />} />
//           <Route path="/contact" element={<Contact role={role} />} />
//           <Route path="/community/:id" element={<ListingDetails role="owner" />} />
//           <Route path="/blogs" element={<Blogs role={role} />} />
//           <Route path="/sell" element={<SellPage role={role} />} />
//           <Route path="/buy" element={<BuyPage role={role} />} />
//           <Route path="/blogs/:id" element={<Blogs role={role} />} />
          
//           {/* 404 route - this needs to be the last route */}
//           <Route path="*" element={<NotFound />} />
//         </Routes>
//       </div>

//       {/* Global WhatsApp button (floats over all pages) */}
//       <WhatsAppButton />

//       {/* Only render the Footer if not on SignIn, SignUp, or 404 page */}
//       {!isAuthPage && !isNotFoundPage && <Footer />}
//     </div>
//   );
// }

// // Make sure to wrap your entire app in the Router component
// export default function WrappedApp() {
//   return (
//     <Router>
//       <App />
//     </Router>
//   );
// }













import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
// import Communities from "./pages/communities";
import Footer from "./components/footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ListingDetails from "./pages/ListingDetails";
import NotFound from "./pages/NotFound"; // Import the NotFound component
import Aos from "aos";
import "aos/dist/aos.css";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import axios from "axios";
import Blogs from "./pages/Blogs";
import SellPage from "./pages/sale";
import BuyPage from "./pages/buy";
import AddCommunityForm from './pages/CommunityForm'
import QuaReports from "./pages/QuaReports";

// axios.defaults.baseURL = 'http://127.0.0.1:5001/'; // local backend
const isProduction = window.location.hostname === 'https://briankarsh.com/';

axios.defaults.baseURL = isProduction
  ? 'https://python-backend-68898252993.us-central1.run.app'
  : 'http://127.0.0.1:5001'
axios.defaults.withCredentials = false  // since you’re sending JWTs, not cookies


// axios.defaults.baseURL = 'https://briankarsh.com'; // local backend

function App() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedRole = localStorage.getItem('role'); // Assuming 'role' is saved in localStorage after login
    setRole(storedRole || 'user'); // Default to 'user' if no role is found
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);

  // Hook to get the current route path
  const location = useLocation();

  // Check if the current route is SignIn or SignUp
  const isAuthPage = location.pathname === "/sign-in" || location.pathname === "/sign-up" ;
  
  // Check if current route is the 404 page to hide navbar and footer
  const isNotFoundPage = location.pathname === "*";

  return (
    <div>
      {/* Conditionally render Navbar and Footer only if not on SignIn, SignUp, or 404 page */}
      {!isAuthPage && !isNotFoundPage && <Navbar />}
      
      <div style={{ margin: 0, padding: 0 }}>
        <Routes>
          <Route path="/" element={<Home role={role} />} />
          <Route path="/sign-in" element={<SignIn />} />
          {/* <Route path="/sign-up" element={<SignUp />} /> */}
          {/* <Route path="/communities" element={<Communities />} /> */}
          <Route path="/about" element={<About role={role} />} />
          <Route path="/contact" element={<Contact role={role} />} />
          <Route path="/community/:id" element={<ListingDetails role={role} />} />
          <Route path="/blogs" element={<Blogs role={role} />} />
          <Route path="/sell" element={<SellPage role={role} />} />
          <Route path="/buy" element={<BuyPage role={role} />} />
          <Route path="/add-community" element={<AddCommunityForm role={role} />} />
          <Route path="/edit-community/:id" element={<AddCommunityForm role={role} />} />
          <Route path="/quarterly-reports" element={<QuaReports role={role} />} />

          <Route path="/blogs/:id" element={<Blogs role={role} />} />
          
          {/* 404 route - this needs to be the last route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {/* Global WhatsApp button (floats over all pages) */}
      <WhatsAppButton />

      {/* Only render the Footer if not on SignIn, SignUp, or 404 page */}
      {!isAuthPage && !isNotFoundPage && <Footer />}
    </div>
  );
}

// Make sure to wrap your entire app in the Router component
export default function WrappedApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}